const dashboard = {
    title: String("Dashboard"),
    noModulesFound: String("You have not registered any module yet! Go to the modules section to register your first module."),
    loadingModules: String("Wait while loading your modules information ..."),
    mapOverlayBoxTitle: String("Select the module"),
    mapOverlayBoxTemperature: String("Temperature"),
    mapOverlayBoxRelHumidity: String("Relative Humidity"),
    mapOverlayBoxRainmeter: String("Pluviometry"),
    noDataForModule: String("This module has reported no data today"),
};

export default dashboard;